<template>
  <div>
    <p v-if="!updates && !loading" class="text-center">
      <b>
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">You have not created any posts yet.</span>
            <button class="get-started-btn" :style="{ background: getSecondaryColor() }" @click="pushToHome">Create Post</button>
          </div>
        </div>
      </b>
    </p>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>

    <div v-if="updates && !loading">
      <p
        :style="{
          'font-weight': '700',
          'font-size': '32px',
          'line-height': '42px',
          color: '#0F1734',
        }"
      >
        Recent Activity
      </p>

      <div v-for="(update, index) in updates" :key="index">
        <!-- <Post v-if="update.content_type === 'post'" :postData="update"></Post>
        <Question
          v-if="update.content_type === 'question'"
          :quesData="update"
        ></Question> -->
        <div v-if="update.content_type === 'post'">
          <Post :postData="update" />
        </div>
        <div v-if="update.content_type === 'poll' && update.user_poll">
          <PollCard :pollData="update.user_poll" />
        </div>
        <div v-if="update.content_type === 'question'">
          <QuestionCard :quesData="update.user_question" />
        </div>
      </div>
      <span
        v-if="updates.length != pagination.total_count"
        class="viewmore"
        :style="{
          color: getPrimaryColor(),
          textAlign: 'center',
          display: 'block',
          cursor: 'pointer',
        }"
        @click="fetch(true)"
        >View More</span
      >
    </div>
  </div>
</template>

<script>
import Post from "../Doctor/PostDoctor.vue"
import QuestionCard from "../Patient/QA/Question"
import PollCard from "../../home/poll/UserPollCard.vue"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientUpdates",
  components: {
    Post,
    QuestionCard,
    PollCard,
  },
  data() {
    return {
      updates: [],
      pagination: null,
      currentPage: 1,
      limit: 2,
      showNo: false,
      loading: false,
    }
  },

  created() {
    console.log(this.authUser.user, "user ")
    this.fetch()
  },

  methods: {
    pushToHome() {
      this.$router.push({ name: "ActivityHome" })
    },
    fetch(append = false) {
      this.loading = true
      console.log("inside fetch")
      UserRepository.getUpdates(this.currentPage, this.limit, this.authUser.user, this.currentCircle.id)
        .then(res => {
          this.showNo = true
          this.loading = false
          console.log(res)
          if (append) {
            this.updates.push(...res.data.data.data)
          } else {
            if (res.data) {
              this.updates = res.data.data.data
              this.pagination = res.data.data.paginator
            }
          }
          this.currentPage += 1
        })
        .catch(err => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.viewmore {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 20px;
}
.get-started-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 121px;
  height: 48px;
  background: #062b54;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
}

.dailog {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/DoctorUpdates.vue